export const defaultPageViewMap = new Map([
    ['CI', 'user_id'],
    ['CG', 'customer_gender_value'],
    ['COP', 'oauth_provider'],
    ['VS', 'value_segment'],
    ['CR', 'login_status']
]);
